import { combineReducers } from 'redux';
import createReducer from 'utils/createReducer';
import {
  NOTIFICATION_SUCCESS,
  NOTIFICATION_WARNING,
  NOTIFICATION_ERROR,
  NOTIFICATION_RESET,
  NOTIFICATION_CLICKED,
} from './types';

const bars = createReducer([], {
  [NOTIFICATION_SUCCESS]: (draft, { payload }) => {
    draft.push({
      level: 'success',
      message: payload.message,
    });
  },
  [NOTIFICATION_WARNING]: (draft, { payload }) => {
    draft.push({
      level: 'warning',
      message: payload.message,
    });
  },
  [NOTIFICATION_ERROR]: (draft, { payload }) => {
    draft.push({
      level: 'error',
      message: payload.message,
    });
  },
  [NOTIFICATION_RESET]: () => [],
});

const notificationClicked = createReducer(false, {
  [NOTIFICATION_CLICKED]: (draft, { payload }) => payload.notificationClicked,
});

export default combineReducers({
  bars,
  notificationClicked,
});
